var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowForward component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowForward extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5284 2.32465C12.2355 2.03176 11.7606 2.03176 11.4677 2.32465C11.1748 2.61754 11.1748 3.09242 11.4677 3.38531L19.3324 11.25H2.85645C2.44223 11.25 2.10645 11.5858 2.10645 12C2.10645 12.4142 2.44223 12.75 2.85645 12.75H19.3324L11.4677 20.6147C11.1748 20.9075 11.1748 21.3824 11.4677 21.6753C11.7606 21.9682 12.2355 21.9682 12.5284 21.6753L21.6734 12.5303C21.9663 12.2374 21.9663 11.7625 21.6734 11.4697L12.5284 2.32465Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowForward.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowForward.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowForward.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-forward') === undefined) {
    customElements.define('cat-icon-arrow-forward', BlocksIconArrowForward);
}
